import { render, staticRenderFns } from "./huandian.vue?vue&type=template&id=452fc87c&scoped=true&"
import script from "./huandian.vue?vue&type=script&setup=true&lang=js&"
export * from "./huandian.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./huandian.vue?vue&type=style&index=0&id=452fc87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452fc87c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('452fc87c')) {
      api.createRecord('452fc87c', component.options)
    } else {
      api.reload('452fc87c', component.options)
    }
    module.hot.accept("./huandian.vue?vue&type=template&id=452fc87c&scoped=true&", function () {
      api.rerender('452fc87c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/components/charts/huandian.vue"
export default component.exports